import {errorLoading, loaded, responseHandler, errorGetStatus, tokenInterceptor, loading, }
  from '../manager/HttpManager'
import { fetchLogoutAction } from './AuthWS'
import { fetchAppsAction } from './AppWS'
import Constants from '../constants/Constants'

let urlServer = Constants.UrlsConstants.urlServer

export const deployWS = (state = { certif: {}, stores: [] }, action) => {
  switch (action.type) {
    case Constants.ActionsConstants.DEPLOY.CERTIF:
      return Object.assign({}, state, { certif: action.datas })
    case Constants.ActionsConstants.DEPLOY.STORES:
      return Object.assign({}, state, { stores: action.datas })
    case Constants.ActionsConstants.DEPLOY.KEYSTORE:
      let newCertif = JSON.parse(JSON.stringify(state.certif))
      let index = newCertif.stores.findIndex(store => store.store === 'ANDROID')
      let store = newCertif.stores[index]
      store.certificateHash = action.datas.certificateHash
      store.certificateName = action.datas.certificateName
      store.generatedKeyStore = action.datas.generatedKeyStore
      store.hasCertificatePassword = action.datas.hasCertificatePassword
      store.hasKeyPassword = action.datas.hasKeyPassword
      store.keyAlias = action.datas.keyAlias
      return Object.assign({}, state, {certif: newCertif})
    default:
      return state
  }
}

export const setCertif = (data) => {
  return {
    type: Constants.ActionsConstants.DEPLOY.CERTIF,
    datas: data,
  }
}

export const setKeyStore = (data) => {
  return {
    type: Constants.ActionsConstants.DEPLOY.KEYSTORE,
    datas: data,
  }
}

export const setStores = (data) => {
  return {
    type: Constants.ActionsConstants.DEPLOY.STORES,
    datas: data,
  }
}

export function fetchDeployActions (dispatch, appId) {
  function fetchCertif () {
    let entryPoint = Constants.UrlsConstants.appsEntryPoint+Constants.MethodsWSConstants.APPS.DETAIL_APP
    let method = appId + '/' + Constants.MethodsWSConstants.APPS.FETCH_APP_DEPLOY

    fetch(urlServer+entryPoint+method, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
    .then(response => {
      tokenInterceptor(response)
      return responseHandler(response)
    })
    .then(r => r.json())
    .then(data => {
      dispatch(setCertif(data))
    })
    .catch(error => {
      if (errorGetStatus(error) === 401) {
        dispatch(errorLoading('Error.Croutons.authExpired'))
        fetchLogoutAction(dispatch).fetchLogout()
      }
    })
  }

  function fetchCGU () {
    let entryPoint = Constants.UrlsConstants.deployEntryPoint
    let method = Constants.MethodsWSConstants.APPS.FETCH_CGU + appId
    fetch(urlServer+entryPoint+method, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
    .then(response => {
      tokenInterceptor(response)
      return responseHandler(response)
    })
    .then(r => r.json())
    .then(data => {
      dispatch(setStores(data))
    })
    .catch(error => {
      if (errorGetStatus(error) === 401) {
        dispatch(errorLoading('Error.Croutons.authExpired'))
        fetchLogoutAction(dispatch).fetchLogout()
      }
    })
  }

  function fetchPrivacyPolicy () {
    let entryPoint = Constants.UrlsConstants.deployEntryPoint
    let method = Constants.MethodsWSConstants.APPS.FETCH_PRIVACY_POLICY + appId
    fetch(urlServer+entryPoint+method, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setStores(data))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  return {
    fetchCertif,
    fetchCGU,
    fetchPrivacyPolicy,
  }
}

export function saveDeployActions (dispatch, certif, appId, stores) {
  function updateCertif () {
    if (certif.appId) {
      let entryPoint = Constants.UrlsConstants.deployEntryPoint
      let method = Constants.MethodsWSConstants.APPS.UPDATE_APP_DEPLOY+certif.appId
      let formData = new FormData()
      let forbidden = ['appId']
      for (let key in certif) {
        if (certif[key] !== '' && !forbidden.includes(key)) {
          formData.append(key, certif[key])
        }
      }
      let headers = {
        'authtoken': Constants.UrlsConstants.header.authtoken,
        'refreshtoken': Constants.UrlsConstants.header.refreshtoken,
      }

      fetch(urlServer+entryPoint+method, {
        method: 'POST',
        body: formData,
        headers,
      })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        dispatch(setCertif(data))
      })
    }
  }

  function askForDeploy () {
    if (certif) {
      let entryPoint = Constants.UrlsConstants.deployEntryPoint
      let method = Constants.MethodsWSConstants.APPS.ASK_DEPLOY+certif + '?sort=store'
      let headers = {
        'authtoken': Constants.UrlsConstants.header.authtoken,
        'refreshtoken': Constants.UrlsConstants.header.refreshtoken,
      }
      fetch(urlServer+entryPoint+method, {
        method: 'GET',
        headers,
      })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        fetchDeployActions(dispatch, certif).fetchCertif()
        fetchAppsAction(dispatch, null, null, null, null, certif).refreshApp()
      })
    }
  }

  function updateCGU () {
    if (stores.length) {
      let entryPoint = Constants.UrlsConstants.deployEntryPoint
      let method = Constants.MethodsWSConstants.APPS.UPDATE_CGU + '/' + appId
      fetch(urlServer+entryPoint+method, {
        method: 'PUT',
        headers: Constants.UrlsConstants.header,
        body: JSON.stringify(stores),
      })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        dispatch(setStores(data))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
    }
  }

  function updatePrivacyPolicy () {
    if (stores.length) {
      let entryPoint = Constants.UrlsConstants.deployEntryPoint
      let method = Constants.MethodsWSConstants.APPS.UPDATE_PRIVACY_POLICY + '/' + appId
      fetch(urlServer+entryPoint+method, {
        method: 'PUT',
        headers: Constants.UrlsConstants.header,
        body: JSON.stringify(stores),
      })
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
        .then(r => r.json())
        .then(data => {
          dispatch(setStores(data))
          dispatch(loaded('Error.Croutons.saveSuccess'))
        })
        .catch(error => {
          if (errorGetStatus(error) === 401) {
            dispatch(errorLoading('Error.Croutons.authExpired'))
            fetchLogoutAction(dispatch).fetchLogout()
          } else {
            dispatch(errorLoading('Error.Croutons.saveError'))
          }
        })
    }
  }

  function generateKeyStore () {
    if (certif) {
      let entryPoint = Constants.UrlsConstants.deployEntryPoint
      let method = Constants.MethodsWSConstants.APPS.GENERATE_KEYSTORE + appId

      let formData = new FormData()
      formData.append('certificatePassword', certif.androidKeystorePassword)
      formData.append('keyAlias', certif.androidKeyAlias)
      formData.append('keyPassword', certif.androidKeyPassword)
      formData.append('generatedKeyStore', certif.androidGeneratedKeyStore)
      formData.append('keyStoreFile', certif.keyStoreFile)

      let headers = {
        'authtoken': Constants.UrlsConstants.header.authtoken,
        'refreshtoken': Constants.UrlsConstants.header.refreshtoken,
      }

      dispatch(loading(''))
      fetch(urlServer+entryPoint+method, {
        method: 'POST',
        headers: headers,
        body: formData,
      })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        dispatch(setKeyStore(data))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
    }
  }

  return {
    updateCertif,
    askForDeploy,
    updateCGU,
    updatePrivacyPolicy,
    generateKeyStore,
  }
}
